/** The filters' date ranges, as their start and end query keys. */
const DATE_RANGES = [
  ['contract_date_start', 'contract_date_end'],
  ['amendment_date_start', 'amendment_date_end'],
  ['collection_date_start', 'collection_date_end'],
] as const;

/** A date as the date inputs write it, which sorts as text in date order. */
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * The query with each date range in order, start on or before end. The
 * pickers keep a range in order, but a link can still carry one back to front,
 * so its two dates are swapped. Returns `params` itself when every range is in
 * order already (or holds something that is not a date), so a caller can tell
 * whether anything changed.
 */
export const orderDateRanges = (params: URLSearchParams): URLSearchParams => {
  let ordered = params;
  for (const [startKey, endKey] of DATE_RANGES) {
    const start = params.get(startKey) ?? '';
    const end = params.get(endKey) ?? '';
    if (ISO_DATE.test(start) && ISO_DATE.test(end) && start > end) {
      if (ordered === params) ordered = new URLSearchParams(params);
      ordered.set(startKey, end);
      ordered.set(endKey, start);
    }
  }
  return ordered;
};
